<template>
  <div id="set-config-page" class="mkt-ops -main-font">
    <div :class="loadData === true ? 'bg-backdrop-setting' : ''"></div>
    <div
      style="position: absolute;top: 50%; left: 52%; width: 10%; z-index: 2;"
      v-show="loadData === true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>

    <div class="head-title-page md-layout">
      MASTER CONFIG
    </div>

    <!-- Block #1 -->
    <div class="header-step">
      <md-avatar class="md-avatar-step">1</md-avatar>
      <div class="head-title">Use product on system</div>
    </div>

    <!-- Campaign -->
    <md-card class="main-content" style="margin-top: 25px;">
      <div class="-head">
        <div
          :style="
            isDelete || isAdd || isEdit
              ? 'width: 50%; display: flex;'
              : 'width: 50%; display: flex; margin: 6px 0px;'
          "
        >
          <md-icon v-show="selectedCampaign === false"
            ><span @click="onSelectedMenu('Campaign')"
              >keyboard_arrow_right</span
            ></md-icon
          >
          <md-icon v-show="selectedCampaign === true"
            ><span @click="onSelectedMenu('Campaign')"
              >keyboard_arrow_down</span
            ></md-icon
          >
          <div class="-title" @click="onSelectedMenu('Campaign')">
            Campaign
          </div>
        </div>

        <div v-show="selectedCampaign === false" class="modify-date">
          Modify [ {{ updateUserCampaign }} {{ modifyDateCampaign }} ]
        </div>

        <div
          class="-save"
          style="width: 50%;"
          v-show="
            selectedCampaign === true &&
              dataCampaign.length > 0 &&
              (isDelete || isAdd || isEdit)
          "
        >
          <md-button class="md-raised md-primary -gray" @click="onSave()"
            >Save</md-button
          >
        </div>
      </div>

      <!-- Campaign :Set Condition -->
      <hr v-show="selectedCampaign === true" class="hr-head" />

      <!-- Campaign :Condition -->
      <div
        v-show="selectedCampaign === true && dataCampaign.length > 0"
        class="-condition"
      >
        <div class="-row" v-for="(item, index) in dataCampaign" :key="index">
          <div class="-text" v-if="index === 0">Product lifecycle code</div>
          <div class="-text" v-else></div>
          <div class="filter-table -input">
            <input
              type="text"
              v-model="dataCampaign[index]"
              placeholder="Key code..."
              :class="isEdit || isAdd ? '' : 'disabled'"
              :disabled="isEdit || isAdd ? false : true"
            />
          </div>

          <!-- DELETE -->
          <div
            v-show="isDelete"
            :class="
              dataCampaign.length > 1 ? '-button delete' : '-button -disabled'
            "
            @click="deleteRow(index)"
          >
            <md-icon title="Delete">remove_circle</md-icon>
          </div>

          <!-- ADD -->
          <div
            class="-button add"
            v-show="index === dataCampaign.length - 1 && isAdd"
            @click="addRow()"
          >
            <md-icon title="Add">add_circle</md-icon>
          </div>
        </div>
      </div>
    </md-card>

    <!-- Price -->
    <md-card class="main-content">
      <div class="-head">
        <div
          :style="
            isDelete || isAdd || isEdit
              ? 'width: 50%; display: flex;'
              : 'width: 50%; display: flex; margin: 6px 0px;'
          "
        >
          <md-icon v-show="selectedPrice === false"
            ><span @click="onSelectedMenu('Price')"
              >keyboard_arrow_right</span
            ></md-icon
          >
          <md-icon v-show="selectedPrice === true"
            ><span @click="onSelectedMenu('Price')"
              >keyboard_arrow_down</span
            ></md-icon
          >
          <div class="-title" @click="onSelectedMenu('Price')">
            Price
          </div>
        </div>

        <div v-show="selectedPrice === false" class="modify-date">
          Modify [ {{ updateUserPrice }} {{ modifyDatePrice }} ]
        </div>

        <div
          class="-save"
          style="width: 50%;"
          v-show="
            selectedPrice === true &&
              dataPrice.length > 0 &&
              (isDelete || isAdd || isEdit)
          "
        >
          <md-button class="md-raised md-primary -gray" @click="onSave()"
            >Save</md-button
          >
        </div>
      </div>

      <hr v-show="selectedPrice === true" class="hr-head" />

      <!-- Price :Condition -->
      <div
        v-show="selectedPrice === true && dataPrice.length > 0"
        class="-condition"
      >
        <div class="-row" v-for="(item, index) in dataPrice" :key="index">
          <div class="-text" v-if="index === 0">Product lifecycle code</div>
          <div class="-text" v-else></div>
          <div class="filter-table -input">
            <input
              type="text"
              v-model="dataPrice[index]"
              placeholder="Key code..."
              :class="isEdit || isAdd ? '' : 'disabled'"
              :disabled="isEdit || isAdd ? false : true"
            />
          </div>

          <!-- DELETE -->
          <div
            v-show="isDelete"
            :class="
              dataPrice.length > 1 ? '-button delete' : '-button -disabled'
            "
            @click="deleteRow(index)"
          >
            <md-icon title="Delete">remove_circle</md-icon>
          </div>

          <!-- ADD -->
          <div
            class="-button add"
            v-show="index === dataPrice.length - 1 && isAdd"
            @click="addRow()"
          >
            <md-icon title="Add">add_circle</md-icon>
          </div>
        </div>
      </div>
    </md-card>

    <!-- Promotion -->
    <md-card class="main-content">
      <div class="-head">
        <div
          :style="
            isDelete || isAdd || isEdit
              ? 'width: 50%; display: flex;'
              : 'width: 50%; display: flex; margin: 6px 0px;'
          "
        >
          <md-icon v-show="selectedPromotion === false"
            ><span @click="onSelectedMenu('Promotion')"
              >keyboard_arrow_right</span
            ></md-icon
          >
          <md-icon v-show="selectedPromotion === true"
            ><span @click="onSelectedMenu('Promotion')"
              >keyboard_arrow_down</span
            ></md-icon
          >
          <div class="-title" @click="onSelectedMenu('Promotion')">
            Promotion
          </div>
        </div>

        <div v-show="selectedPromotion === false" class="modify-date">
          Modify [ {{ updateUserPromotion }} {{ modifyDatePromotion }} ]
        </div>

        <div
          class="-save"
          style="width: 50%;"
          v-show="
            selectedPromotion === true &&
              dataPromotion.length > 0 &&
              (isDelete || isAdd || isEdit)
          "
        >
          <md-button class="md-raised md-primary -gray" @click="onSave()"
            >Save</md-button
          >
        </div>
      </div>

      <hr v-show="selectedPromotion === true" class="hr-head" />

      <!-- Promotion :Condition -->
      <div
        v-show="selectedPromotion === true && dataPromotion.length > 0"
        class="-condition"
      >
        <div class="-row" v-for="(item, index) in dataPromotion" :key="index">
          <div class="-text" v-if="index === 0">Product lifecycle code</div>
          <div class="-text" v-else></div>
          <div class="filter-table -input">
            <input
              type="text"
              v-model="dataPromotion[index]"
              placeholder="Key code..."
              :class="isEdit || isAdd ? '' : 'disabled'"
              :disabled="isEdit || isAdd ? false : true"
            />
          </div>

          <!-- DELETE -->
          <div
            v-show="isDelete"
            :class="
              dataPromotion.length > 1 ? '-button delete' : '-button -disabled'
            "
            @click="deleteRow(index)"
          >
            <md-icon title="Delete">remove_circle</md-icon>
          </div>

          <!-- ADD -->
          <div
            class="-button add"
            v-show="index === dataPromotion.length - 1 && isAdd"
            @click="addRow()"
          >
            <md-icon title="Add">add_circle</md-icon>
          </div>
        </div>
      </div>
    </md-card>

    <!-- Block #2 -->
    <div class="header-step">
      <md-avatar class="md-avatar-step">2</md-avatar>
      <div class="head-title">Customer group set for use...</div>
    </div>

    <!-- Customer Group -->
    <md-card class="main-content" style="margin-top: 25px;">
      <div class="-head">
        <div
          :style="
            isDelete || isAdd || isEdit
              ? 'width: 50%; display: flex;'
              : 'width: 50%; display: flex; margin: 6px 0px;'
          "
        >
          <md-icon v-show="selectedCustomerGroup === false"
            ><span @click="onSelectedMenu('CustomerGroup')"
              >keyboard_arrow_right</span
            ></md-icon
          >
          <md-icon v-show="selectedCustomerGroup === true"
            ><span @click="onSelectedMenu('CustomerGroup')"
              >keyboard_arrow_down</span
            ></md-icon
          >
          <div class="-title" @click="onSelectedMenu('CustomerGroup')">
            Auto insert customer code to customer group
          </div>
        </div>

        <div v-show="selectedCustomerGroup === false" class="modify-date">
          Modify [ {{ updateUserCustomerGroup }} {{ modifyDateCustomerGroup }} ]
        </div>

        <div
          class="-save"
          style="width: 50%;"
          v-show="
            selectedCustomerGroup === true &&
              dataCustomerGroup.length > 0 &&
              (isDelete || isAdd || isEdit)
          "
        >
          <md-button class="md-raised md-primary -gray" @click="onSave()"
            >Save</md-button
          >
        </div>
      </div>

      <!-- CustomerGroup :Set Condition -->
      <hr v-show="selectedCustomerGroup === true" class="hr-head" />

      <!-- CustomerGroup :Condition -->
      <div
        v-show="selectedCustomerGroup === true && dataCustomerGroup.length > 0"
        class="-condition"
      >
        <div v-for="(item, index) in dataCustomerGroup" :key="index">
          <div style="width: 100%; display: flex;">
            <div class="-text" style="width: 20%;">Customer Group</div>
            <multiselect
              v-model="item.group_code"
              label="group_name"
              track-by="group_code"
              placeholder="+ Search Customer Group"
              :options="customerGroups"
              :searchable="true"
              :max-height="170"
              :show-no-results="false"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              style="margin-top:22px; width: 33%;"
              :class="isEdit || isAdd ? '' : 'disabled'"
              :disabled="isEdit || isAdd ? false : true"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div class="-label">{{ option.group_name }}</div>
                  <!-- <div
                    class="-delete"
                    @mousedown.prevent.stop="
                      clearAll(option.id, 'customergroup')
                    "
                  >
                    <i class="material-icons">close</i>
                  </div> -->
                </div>
              </template>
            </multiselect>
            <!-- DELETE -->
            <div
              v-show="isDelete"
              :class="
                dataCustomerGroup.length > 1
                  ? '-button delete'
                  : '-button -disabled'
              "
              style="margin-top: 30px;"
              @click="deleteRow(index)"
            >
              <md-icon title="Delete">remove_circle</md-icon>
            </div>

            <!-- ADD -->
            <div
              class="-button add"
              style="margin-top: 30px;"
              v-show="index === dataCustomerGroup.length - 1 && isAdd"
              @click="addRow()"
            >
              <md-icon title="Add">add_circle</md-icon>
            </div>
          </div>

          <div style="width: 100%; display: flex;">
            <div style="width: 20%;"></div>
            <div class="-text">Customer Start Value</div>
            <div class="filter-table -input">
              <input
                type="text"
                style="text-align: right;"
                v-model="item.cust_code_start"
                placeholder="Key code..."
                @keypress="isNumber"
                :class="isEdit || isAdd ? '' : 'disabled'"
                :disabled="isEdit || isAdd ? false : true"
              />
            </div>
          </div>
        </div>
      </div>
    </md-card>

    <!-- Block #3 -->
    <div class="header-step">
      <md-avatar class="md-avatar-step">3</md-avatar>
      <div class="head-title">Change of person in charge</div>
    </div>

    <!-- Person Charge -->
    <md-card class="main-content" style="margin-top: 25px;">
      <div class="-head">
        <div style="width: 50%; display: flex;">
          <md-icon
            ><span @click="openDialogPromotion()"
              >keyboard_arrow_right</span
            ></md-icon
          >
          <div class="-title" @click="openDialogPromotion()">
            Promotion
          </div>
        </div>
      </div>
    </md-card>

    <!-- Volume Discount -->
    <md-card class="main-content">
      <div class="-head">
        <div style="width: 50%; display: flex;">
          <md-icon
            ><span @click="openDialogVD()">keyboard_arrow_right</span></md-icon
          >
          <div class="-title" @click="openDialogVD()">
            Volume Discount
          </div>
        </div>
      </div>
    </md-card>

    <!-- Dialog Promotion -->
    <DialogPromotion
      v-model="showDialogPromotion"
      :dpUserAccount="dpUserAccount"
      @clickCancel="cancelPromotion"
      @clickUpdate="updatePromotion"
    ></DialogPromotion>

    <DialogVolumediscount
      v-model="showDialogVD"
      :dpUserAccount="dpUserAccount"
      @clickCancel="cancelVD"
      @clickUpdate="updateVD"
    ></DialogVolumediscount>

    <md-dialog-confirm
      :md-active.sync="confirmChange"
      :md-title="titleConfirm"
      :md-content="textConfirm"
      :md-confirm-text="textBtnConfirm"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />

    <!-- <md-dialog-confirm
      class="dialog-alert-null"
      :md-active.sync="confirmSave"
      md-title="Do you sure you want to save ?"
      md-content="Product lifecycle code is NULL"
      md-confirm-text="Save"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    /> -->

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import SettingService from "@/services/setting";
import promotionService from "@/services/promotion";
import UserService from "@/services/user";
import moment from "moment-timezone";
import DialogPromotion from "./../system/set-config/dialog-promotion";
import DialogVolumediscount from "./../system/set-config/dialog-volumediscount";

export default {
  name: "set-config",
  components: {
    DialogPromotion,
    DialogVolumediscount
  },
  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isAdd() {
      return this.permit.acl["setting"].menus["set-config"].add;
    },
    isEdit() {
      return this.permit.acl["setting"].menus["set-config"].edit;
    },
    isDelete() {
      return this.permit.acl["setting"].menus["set-config"].delete;
    }
  },
  data() {
    return {
      loadData: false,
      dataUser: "",
      confirmChange: false,
      // confirmSave: false,
      titleConfirm: "Confirm ?",
      textConfirm: "",
      textBtnConfirm: "",
      typeDialog: "",
      selectedMenu: "",
      codeOnSelectedMenu: "",
      selectedCampaign: false,
      dataCampaign: [],
      tmpDataCampaign: [],
      dataCampaign: [],
      tmpDataCampaign: [],
      updateUserCampaign: "",
      modifyDateCampaign: "",
      selectedPrice: false,
      dataPrice: [],
      tmpDataPrice: [],
      dataPrice: [],
      tmpDataPrice: [],
      updateUserPrice: "",
      modifyDatePrice: "",
      selectedPromotion: false,
      dataPromotion: [],
      tmpDataPromotion: [],
      dataPromotion: [],
      tmpDataPromotion: [],
      updateUserPromotion: "",
      modifyDatePromotion: "",
      selectedCustomerGroup: false,
      dataCustomerGroup: [],
      tmpDataCustomerGroup: [],
      dataCustomerGroup: [],
      tmpDataCustomerGroup: [],
      updateUserCustomerGroup: "",
      modifyDateCustomerGroup: "",
      customerGroups: [],
      showSnackbar: false,
      dContent: "",
      position: "center",
      duration: 20000,
      isInfinity: false,
      showDialogPromotion: false,
      showDialogVD: false,
      dpUserAccount: []
    };
  },
  created() {
    this.dataUser = this.$jwt.decode(localStorage.getItem("token"));
    promotionService.getCustomerGroups().then(response => {
      for (let i = 0; i < response.length; i++) {
        if (response[i].group_name != "") {
          this.customerGroups.push({
            group_code: response[i].group_code,
            group_name: response[i].group_name
          });
        }
      }
      this.getData();
    });

    UserService.getUserConfig().then(response => {
      if (response && response.length > 0) {
        this.dpUserAccount = response;
      }
    });
  },
  mounted() {},
  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        this.keepEvent = false;
        evt.preventDefault();
      } else {
        this.keepEvent = true;
        return true;
      }
    },
    onCancel() {
      if (this.typeDialog === "Save") {
        this.selectedCampaign = false;
        this.selectedPrice = false;
        this.selectedPromotion = false;
        this.selectedCustomerGroup = false;
        this.$store.dispatch("setconfig/setUpdateData", false);
        this.getData();
      }
      this.selectedMenu = "";
      this.confirmChange = false;
      // this.confirmSave = false;
    },
    onConfirm() {
      if (this.typeDialog === "Save") {
        let dataSave;
        if (this.selectedMenu === "Campaign") {
          this.codeOnSelectedMenu = "select_product_cycle_campaign";
          dataSave = this.dataCampaign;
        } else if (this.selectedMenu === "Price") {
          this.codeOnSelectedMenu = "select_product_cycle_pricing";
          dataSave = this.dataPrice;
        } else if (this.selectedMenu === "Promotion") {
          this.codeOnSelectedMenu = "select_product_cycle_pomotion";
          dataSave = this.dataPromotion;
        } else if (this.selectedMenu === "CustomerGroup") {
          this.codeOnSelectedMenu = "auto_insert_customer_group";
          let dataArr = [];
          for (let i = 0; i < this.dataCustomerGroup.length; i++) {
            dataArr[i] = this.dataCustomerGroup[i];
            dataArr[i].group_code = this.dataCustomerGroup[
              i
            ].group_code.group_code;

            /* START Check date field c_time */
            if (
              this.dataCustomerGroup[i].c_time !== undefined &&
              this.dataCustomerGroup[i].c_time !== null
            ) {
              if (
                this.tmpDataCustomerGroup[i].group_code.group_code ===
                  dataArr[i].group_code &&
                this.tmpDataCustomerGroup[i].cust_code_start ===
                  dataArr[i].cust_code_start
              ) {
                //ค่าเดิม ไม่ได้แก้ไข ลงเวลาเดิม
                dataArr[i].c_time = this.dataCustomerGroup[i].c_time;
              } else {
                //แก้ไข เปลี่ยนค่่าจากตัวเดิม
                dataArr[i].c_time = moment(new Date()).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
              }
            } else {
              dataArr[i].c_time = moment(new Date()).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
            /* END Check date field c_time */
          }
          dataSave = dataArr;
        }

        this.loadData = true;
        let datas = {
          code: this.codeOnSelectedMenu,
          usercode: this.dataUser.code,
          u_user: this.dataUser.username,
          option: dataSave
        };
        // console.log("datas ==>", datas);

        let self = this;
        SettingService.updateConfig(datas).then(response => {
          if (response) {
            self.getData();
          }
          self.loadData = false;
        });

        if (self.selectedMenu === "Campaign") {
          self.selectedCampaign = false;
        } else if (self.selectedMenu === "Price") {
          self.selectedPrice = false;
        } else if (self.selectedMenu === "Promotion") {
          self.selectedPromotion = false;
        } else if (self.selectedMenu === "CustomerGroup") {
          self.selectedCustomerGroup = false;
        }
      }
      this.selectedMenu = "";
      this.typeDialog = "";
      this.confirmChange = false;
      this.$store.dispatch("setconfig/setUpdateData", false);
      // this.confirmSave = false;
    },
    onSelectedMenu(menu) {
      if (menu !== this.selectedMenu && this.selectedMenu !== "") {
        //*** Check การเปลี่ยนเมนู ***//
        if (menu === "Campaign") {
          if (this.selectedMenu === "Price") {
            // this.selectedCampaign = true;
            let check = this.compareData(this.tmpDataPrice, this.dataPrice);
            if (check === true) {
              this.selectedPrice = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("Price");
            }
          } else if (this.selectedMenu === "Promotion") {
            // this.selectedPromotion = true;
            let check = this.compareData(
              this.tmpDataPromotion,
              this.dataPromotion
            );
            if (check === true) {
              this.selectedPromotion = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("Promotion");
            }
          } else if (this.selectedMenu === "CustomerGroup") {
            let check =
              JSON.stringify(this.tmpDataCustomerGroup) ===
              JSON.stringify(this.dataCustomerGroup);

            if (check === true) {
              this.selectedCustomerGroup = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("CustomerGroup");
            }
          }
          this.selectedCampaign = true;

          // let check = this.compareData(this.tmpDataCampaign, this.dataCampaign);
          // if (check === true) {
          //   this.selectedCampaign = false;
          //   if (this.selectedMenu === "Price") {
          //     this.selectedPrice = true;
          //   } else if (this.selectedMenu === "Promotion") {
          //     this.selectedPromotion = true;
          //   }
          // } else {
          //   //have change value
          //   this.onSave("Campaign");
          // }
        } else if (menu === "Price") {
          if (this.selectedMenu === "Campaign") {
            // this.selectedCampaign = true;
            let check = this.compareData(
              this.tmpDataCampaign,
              this.dataCampaign
            );
            if (check === true) {
              this.selectedCampaign = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("Campaign");
            }
          } else if (this.selectedMenu === "Promotion") {
            // this.selectedPromotion = true;
            let check = this.compareData(
              this.tmpDataPromotion,
              this.dataPromotion
            );
            if (check === true) {
              this.selectedPromotion = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("Promotion");
            }
          } else if (this.selectedMenu === "CustomerGroup") {
            let check =
              JSON.stringify(this.tmpDataCustomerGroup) ===
              JSON.stringify(this.dataCustomerGroup);

            if (check === true) {
              this.selectedCustomerGroup = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("CustomerGroup");
            }
          }
          this.selectedPrice = true;

          // let check = this.compareData(this.tmpDataPrice, this.dataPrice);
          // if (check === true) {
          //   this.selectedPrice = false;
          //   if (this.selectedMenu === "Campaign") {
          //     this.selectedCampaign = true;
          //   } else if (this.selectedMenu === "Promotion") {
          //     this.selectedPromotion = true;
          //   }
          // } else {
          //   //have change value
          //   this.onSave("Campaign");
          // }
        } else if (menu === "Promotion") {
          if (this.selectedMenu === "Campaign") {
            // this.selectedCampaign = true;
            let check = this.compareData(
              this.tmpDataCampaign,
              this.dataCampaign
            );
            if (check === true) {
              this.selectedCampaign = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("Campaign");
            }
          } else if (this.selectedMenu === "Price") {
            // this.selectedCampaign = true;
            let check = this.compareData(this.tmpDataPrice, this.dataPrice);
            if (check === true) {
              this.selectedPrice = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("Price");
            }
          } else if (this.selectedMenu === "CustomerGroup") {
            let check =
              JSON.stringify(this.tmpDataCustomerGroup) ===
              JSON.stringify(this.dataCustomerGroup);

            if (check === true) {
              this.selectedCustomerGroup = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("CustomerGroup");
            }
          }
          this.selectedPromotion = true;
        } else if (menu === "CustomerGroup") {
          if (this.selectedMenu === "Campaign") {
            // this.selectedCampaign = true;
            let check = this.compareData(
              this.tmpDataCampaign,
              this.dataCampaign
            );
            if (check === true) {
              this.selectedCampaign = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("Campaign");
            }
          } else if (this.selectedMenu === "Price") {
            // this.selectedCampaign = true;
            let check = this.compareData(this.tmpDataPrice, this.dataPrice);
            if (check === true) {
              this.selectedPrice = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("Price");
            }
          } else if (this.selectedMenu === "Promotion") {
            // this.selectedPromotion = true;
            let check = this.compareData(
              this.tmpDataPromotion,
              this.dataPromotion
            );
            if (check === true) {
              this.selectedPromotion = false;
              this.selectedMenu = menu;
            } else {
              //have change value
              this.onSave("Promotion");
            }
          }
          this.selectedCustomerGroup = true;
        }
      } else {
        //*** Check กรณีเลือก เปิด-ปิด ที่เมนูเดิม ***//
        this.selectedMenu = menu;
        if (menu === "Campaign") {
          this.codeOnSelectedMenu = "select_product_cycle_campaign";

          if (this.selectedCampaign === false) {
            this.selectedCampaign = true;
            this.selectedPrice = false;
            this.selectedPromotion = false;
            this.selectedCustomerGroup = false;
          } else {
            let check = this.compareData(
              this.tmpDataCampaign,
              this.dataCampaign
            );

            if (check === true) {
              this.selectedCampaign = false;
            } else {
              //have change value
              this.onSave();
            }
          }
        } else if (menu === "Price") {
          this.codeOnSelectedMenu = "select_product_cycle_pricing";

          if (this.selectedPrice === false) {
            this.selectedPrice = true;
            this.selectedCampaign = false;
            this.selectedPromotion = false;
            this.selectedCustomerGroup = false;
          } else {
            let check = this.compareData(this.tmpDataPrice, this.dataPrice);

            if (check === true) {
              this.selectedPrice = false;
            } else {
              //have change value
              this.onSave();
            }
          }
        } else if (menu === "Promotion") {
          this.codeOnSelectedMenu = "select_product_cycle_pomotion";

          if (this.selectedPromotion === false) {
            this.selectedPromotion = true;
            this.selectedPrice = false;
            this.selectedCampaign = false;
            this.selectedCustomerGroup = false;
          } else {
            let check = this.compareData(
              this.tmpDataPromotion,
              this.dataPromotion
            );

            if (check === true) {
              this.selectedPromotion = false;
            } else {
              //have change value
              this.onSave();
            }
          }
        } else if (menu === "CustomerGroup") {
          this.codeOnSelectedMenu = "auto_insert_customer_group";

          if (this.selectedCustomerGroup === false) {
            this.selectedCustomerGroup = true;
            this.selectedPromotion = false;
            this.selectedPrice = false;
            this.selectedCampaign = false;
          } else {
            // let dataArr = [];
            // console.log("this.dataCustomerGroup ==>", this.dataCustomerGroup);
            // console.log(
            //   "this.tmpDataCustomerGroup ==>",
            //   this.tmpDataCustomerGroup
            // );
            // for (let i = 0; i < this.dataCustomerGroup.length; i++) {
            //   dataArr[i] = this.dataCustomerGroup[i];
            //   dataArr[i].group_code = this.dataCustomerGroup[i].group_code.group_code;
            // }
            // console.log("dataArr ==>", dataArr);

            // let check = this.compareData(
            //   this.tmpDataCustomerGroup,
            //   this.dataCustomerGroup
            //   // dataArr
            // );

            let check =
              JSON.stringify(this.tmpDataCustomerGroup) ===
              JSON.stringify(this.dataCustomerGroup);

            if (check === true) {
              this.selectedCustomerGroup = false;
            } else {
              //have change value
              this.onSave();
            }
          }
        }
      }
    },
    compareData(arr1, arr2) {
      let check =
        arr1.length === arr2.length &&
        arr1.every(function(value, index) {
          return value === arr2[index];
        });
      // arr1.sort().every(function(value, index) {
      //   return value === arr2.sort()[index];
      // });
      return check;
    },
    // saveData() {
    //   this.titleConfirm = "Confirm ?";
    //   this.textConfirm = "Do you sure you want to save ?";
    //   this.textBtnConfirm = "Save";
    //   this.typeDialog = "Save";
    //   this.confirmChange = true;
    // },
    getData() {
      let self = this;
      SettingService.getConfig().then(response => {
        if (response) {
          this.$store.dispatch("setconfig/setDataMasterConfig", response);
          // this.$store.dispatch("setconfig/setUpdateData", false);
          let update_data = self.$store.getters["setconfig/updateData"];

          response.forEach(data => {
            if (data.code === "select_product_cycle_pricing") {
              if (update_data === true) {
                let data_price = self.$store.getters["setconfig/dataPrice"];
                self.dataPrice = data_price;
              } else {
                self.dataPrice = data.option;
                self.tmpDataPrice = JSON.parse(JSON.stringify(data.option));
                this.$store.dispatch("setconfig/setUpdateData", false);
              }
              self.updateUserPrice = data.u_user ? data.u_user : "";
              self.modifyDatePrice = moment(data.u_date).format("DD/MM/YYYY");
            }

            if (data.code === "select_product_cycle_pomotion") {
              if (update_data === true) {
                let data_promotion =
                  self.$store.getters["setconfig/dataPromotion"];
                self.dataPromotion = data_promotion;
              } else {
                self.dataPromotion = data.option;
                self.tmpDataPromotion = JSON.parse(JSON.stringify(data.option));
                this.$store.dispatch("setconfig/setUpdateData", false);
              }
              self.updateUserPromotion = data.u_user ? data.u_user : "";
              self.modifyDatePromotion = moment(data.u_date).format(
                "DD/MM/YYYY"
              );
            }

            if (data.code === "select_product_cycle_campaign") {
              if (update_data === true) {
                let data_campaign =
                  self.$store.getters["setconfig/dataCampaign"];
                self.dataCampaign = data_campaign;
                // self.selectedCampaign = true;
              } else {
                self.dataCampaign = data.option;
                self.tmpDataCampaign = JSON.parse(JSON.stringify(data.option));
                this.$store.dispatch("setconfig/setUpdateData", false);
              }

              self.updateUserCampaign = data.u_user ? data.u_user : "";
              self.modifyDateCampaign = moment(data.u_date).format(
                "DD/MM/YYYY"
              );
            }

            if (data.code === "auto_insert_customer_group") {
              self.dataCustomerGroup = data.option;

              if (update_data === true) {
                let data_customer_group =
                  self.$store.getters["setconfig/dataCustomerGroup"];
                self.dataCustomerGroup = data_customer_group;
              } else {
                /* START set value in autocomplete Customer Group */
                for (let i = 0; i < self.dataCustomerGroup.length; i++) {
                  let index = self.customerGroups.findIndex(
                    item =>
                      item.group_code === self.dataCustomerGroup[i].group_code
                  );
                  if (index > -1) {
                    self.dataCustomerGroup[i].group_code =
                      self.customerGroups[index];
                  }
                }
                /* END set value in autocomplete Customer Group */
                self.tmpDataCustomerGroup = JSON.parse(
                  JSON.stringify(self.dataCustomerGroup)
                );
              }

              // console.log("self.dataCustomerGroup ==>", self.dataCustomerGroup);

              self.updateUserCustomerGroup = data.u_user ? data.u_user : "";
              self.modifyDateCustomerGroup = moment(data.u_date).format(
                "DD/MM/YYYY"
              );
            }
          });
        }
        this.loadData = false;
      });
    },
    addRow() {
      this.$store.dispatch("setconfig/setUpdateData", true);

      if (this.selectedMenu === "Campaign") {
        this.$store.dispatch("setconfig/updateCampaign", this.dataCampaign);
        this.dataCampaign.push("");
      } else if (this.selectedMenu === "Price") {
        this.$store.dispatch("setconfig/updatePrice", this.dataPrice);
        this.dataPrice.push("");
      } else if (this.selectedMenu === "Promotion") {
        this.$store.dispatch("setconfig/updatePromotion", this.dataPromotion);
        this.dataPromotion.push("");
      } else if (this.selectedMenu === "CustomerGroup") {
        this.$store.dispatch(
          "setconfig/updateCustomerGroup",
          this.dataCustomerGroup
        );
        this.dataCustomerGroup.push({
          group_code: "",
          group_name: "",
          other_condition: '{"lob_code":{"$nin": ["DE29","DE32"]}}'
        });
      }
    },
    deleteRow(index) {
      this.$store.dispatch("setconfig/setUpdateData", true);
      if (this.selectedMenu === "Campaign") {
        if (this.dataCampaign.length > 1) {
          this.dataCampaign.splice(index, 1);
        }
        this.$store.dispatch("setconfig/updateCampaign", this.dataCampaign);
      } else if (this.selectedMenu === "Price") {
        if (this.dataPrice.length > 1) {
          this.dataPrice.splice(index, 1);
        }
        this.$store.dispatch("setconfig/updatePrice", this.dataPrice);
      } else if (this.selectedMenu === "Promotion") {
        if (this.dataPromotion.length > 1) {
          this.dataPromotion.splice(index, 1);
        }
        this.$store.dispatch("setconfig/updatePromotion", this.dataPromotion);
      } else if (this.selectedMenu === "CustomerGroup") {
        if (this.dataCustomerGroup.length > 1) {
          this.dataCustomerGroup.splice(index, 1);
        }
        this.$store.dispatch(
          "setconfig/updateCustomerGroup",
          this.dataCustomerGroup
        );
      }
    },
    onSave(menu = "") {
      // let self = this;
      let check = false;
      let changeMenu = false;
      if (this.selectedMenu === "Campaign" || menu === "Campaign") {
        if (menu === "Campaign") {
          changeMenu = true;
        }

        this.dataCampaign.forEach(data => {
          if (data.trim() === "") {
            // self.dContent = "Product lifecycle code can not null.";
            // self.showSnackbar = true;
            check = true;
            return false;
          }
        });
      } else if (this.selectedMenu === "Price" || menu === "Price") {
        if (menu === "Price") {
          changeMenu = true;
        }

        this.dataPrice.forEach(data => {
          if (data.trim() === "") {
            check = true;
            return false;
          }
        });
      } else if (this.selectedMenu === "Promotion" || menu === "Promotion") {
        if (menu === "Promotion") {
          changeMenu = true;
        }

        this.dataPromotion.forEach(data => {
          if (data.trim() === "") {
            check = true;
            return false;
          }
        });
      } else if (
        this.selectedMenu === "CustomerGroup" ||
        menu === "CustomerGroup"
      ) {
        if (menu === "CustomerGroup") {
          changeMenu = true;
        }

        this.dataCustomerGroup.forEach(data => {
          if (data.group_code.group_code == undefined) {
            // check = true;
            this.dContent = "Please select Customer Group.";
            this.showSnackbar = true;
            return false;
          } else if (
            data.group_code.group_code.trim() === "" ||
            data.cust_code_start.trim() === ""
          ) {
            check = true;
            return false;
          }
        });
      }

      if (this.showSnackbar !== true) {
        this.typeDialog = "Save";
        if (this.selectedMenu === "CustomerGroup" || menu === "CustomerGroup") {
          if (changeMenu === true && check === true) {
            //มีการเปลี่ยนเมนู และมีค่าว่าง
            this.titleConfirm = "Do you sure you want to save ?";
            this.textConfirm =
              menu +
              " have change value and Customer Group or Customer Start Value is NULL.";
            this.textBtnConfirm = "Save";
            this.confirmChange = true;
          } else {
            //ทำที่เมนูตัวเอง และมีค่าว่าง
            this.titleConfirm = "Do you sure you want to save ?";
            this.textConfirm =
              "Customer Group or Customer Start Value is NULL.";
            this.textBtnConfirm = "Save";
            this.confirmChange = true;
          }
        } else {
          if (changeMenu === true && check === true) {
            //มีการเปลี่ยนเมนู และมีค่าว่าง
            this.titleConfirm = "Do you sure you want to save ?";
            this.textConfirm =
              menu + " have change value and Product lifecycle code is NULL.";
            this.textBtnConfirm = "Save";
            this.confirmChange = true;
          } else {
            //ทำที่เมนูตัวเอง และมีค่าว่าง
            this.titleConfirm = "Do you sure you want to save ?";
            this.textConfirm = "Product lifecycle code is NULL.";
            this.textBtnConfirm = "Save";
            this.confirmChange = true;
          }
        }

        if (changeMenu === true && check === false) {
          //มีการเปลี่ยนเมนู ไม่มีค่าว่าง
          this.titleConfirm = "Confirm ?";
          this.textConfirm = "Do you sure you want to save " + menu + " ?";
          this.textBtnConfirm = "Save";
          this.confirmChange = true;
        } else if (changeMenu === false && check === false) {
          //ทำที่เมนูตัวเอง ไม่มีค่าว่าง
          this.titleConfirm = "Confirm ?";
          this.textConfirm = "Do you sure you want to save ?";
          this.textBtnConfirm = "Save";
          this.confirmChange = true;
        }
      }
    },
    openDialogPromotion() {
      this.showDialogPromotion = true;
    },
    cancelPromotion() {
      this.showDialogPromotion = false;
    },
    updatePromotion() {
      this.showDialogPromotion = false;
    },
    openDialogVD() {
      this.showDialogVD = true;
    },
    cancelVD() {
      this.showDialogVD = false;
    },
    updateVD() {
      this.showDialogVD = false;
    }
  }
};
</script>

<style lang="scss">
$color-primary: #3f51b5;

#set-config-page {
  background-color: #fff;
  padding: 18px 18px;
  font-family: lato;
  font-size: 14px;
  font-weight: 500;
  height: 100vh;
  overflow-y: auto;

  .head-title-page {
    font-size: 18px;
    font-weight: bold;
    color: #797979;
  }

  .header-step {
    display: flex;
    padding-top: 40px;
    padding-left: 25px;

    .md-avatar-step {
      min-height: 26px;
      min-width: 26px;
      width: 26px;
      height: 26px;
      font-size: 14px;
      color: white;
      background-color: $color-primary;
      margin-left: 0px;
      margin-right: 0px;
    }

    .head-title {
      font-size: 14px;
      font-weight: bold;
      color: $color-primary;
      margin-left: 15px;
      margin-top: 4px;
    }
  }

  .main-content {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);
    margin-left: 68px;
    margin-right: 68px;
    padding: 15px 30px;

    .-head {
      display: flex;

      .md-icon {
        font-size: 20px !important;
        margin-left: 0px;
        margin-right: 0px;
        cursor: pointer;
      }

      .-title {
        margin-left: 12px;
        margin-top: auto;
        margin-bottom: auto;
        cursor: pointer;
      }

      .modify-date {
        width: 50%;
        height: 36px;
        padding-top: 8px;
        text-align: right;
      }

      .-save {
        text-align: right;

        .md-button {
          margin: 0px;
        }
      }
    }

    .hr-head {
      margin-top: 15px;
      opacity: 0.2;
    }

    .-detail {
      padding: 10px 30px;

      .md-button.md-primary.-gray {
        background: #70707080;
        padding: 0px 15px;
      }
    }

    .-condition {
      padding: 5px 30px 15px 30px;

      .-row {
        display: flex;
      }

      .-text {
        width: 18%;
        margin-top: 22px;
      }

      .-input {
        width: 15%;
        text-align: left;
      }

      .-button {
        margin: 21px 0px 0px 25px;
        font-weight: bold;

        &.add,
        &.add .md-icon {
          // color: $color-primary;
          color: green;
          cursor: pointer;
        }
        &.delete,
        &.delete .md-icon {
          color: red;
          cursor: pointer;
        }
        &.-disabled {
          color: #a8a8a8 !important;
        }
      }

      .filter-table {
        text-align: right;
        margin-right: 5px;

        input {
          width: 100%;
          margin-top: 14px;
          padding-left: 8px;
          padding-right: 13.8px;
          height: 36px;
          border: 1px solid #ddd;
          border-radius: 5px;
          background: #fff;

          &.disabled {
            background-color: #f1f1f1;
          }
        }

        ::placeholder {
          color: #bdbdbd;
          opacity: 1;
          font-family: kanit;
          font-size: 12px;
          font-weight: 100;
        }
      }

      .multiselect {
        &.disabled {
          .multiselect__single,
          .multiselect__input {
            width: 95%;
            color: black;
          }
        }

        .z-index-top {
          z-index: 10;
        }

        margin: 5px 0px;

        .multiselect__single,
        .multiselect__input {
          font-size: 14px;

          div {
            display: flex;
            width: 100%;

            .-delete {
              width: 5%;

              .material-icons {
                font-size: 18px;
                margin-top: 1px;
                cursor: pointer;
                color: gray;
              }
            }
          }
        }

        .multiselect__tags {
          padding: 8px 30px 0 8px;

          input {
            font-family: lato;
            font-weight: 300;
          }

          .multiselect__placeholder {
            margin: 0px;
          }

          ::placeholder {
            color: #bdbdbd;
            opacity: 1;
          }
        }

        .multiselect__content-wrapper {
          font-size: 14px;
          z-index: 10;
        }

        .multiselect__option {
          min-height: 34px;
          padding: 12px 12px 0px 12px;
        }

        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
      }
    }
  }

  &::-webkit-scrollbar {
    height: 7px;
    width: 6px;
  }

  .bg-backdrop-setting {
    background: rgba(0, 0, 0, 0.35);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 15;
    top: 0;
    left: 0;
  }
}

// .dialog-alert-null {
//   .md-title {
//     color: red;
//   }
// }
</style>
